// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  stravaClientId: 54930,
  stravaSecret: 'fe5cf6fb037253c6ab36d17025c265991cc4c826',
  garminConsumerKey: 'cbaf5775-5a8d-4a7c-bbf2-56fea5f4d6f6',
  garminSecret: 'Olp5qWrNq4qslTK5NE8TNN3QBhaDyW5LwNq',
  mapBoxApiKey:
    'pk.eyJ1IjoiYWxleGNocmlzdG91IiwiYSI6ImNrejl6cG9uNzAybnIydXNhdThnMDNreGgifQ.jIl3CqAQP4Gz6ugpL__Uiw',
  gridaApiKey: '-',
  geoApify: '24ab63486ce04316a5eba50c44a30090',
  weatherApiKey: '1aed59bbfc444291a9a92058231408',
  // test ads
  bannerAdId: 'ca-app-pub-3940256099942544/6300978111',
  rewardAdId: 'ca-app-pub-3940256099942544/5224354917',
  firebaseConfig : {
    apiKey: 'AIzaSyCrV6VVBD-2RVbnlrYPLQWlYirETBvwhHw',
    authDomain: 'runnergram-c61aa.firebaseapp.com',
    projectId: 'runnergram-c61aa',
    storageBucket: 'runnergram-c61aa.firebasestorage.app',
    messagingSenderId: '241825845507',
    appId: '1:241825845507:web:47d61dd7516ae6f94a9936',
    measurementId: 'G-X76RYRPJQ1'
  }
  // production ads
  //bannerAdId: 'ca-app-pub-9510227041448848/3720036397',
  //rewardAdId: 'ca-app-pub-9510227041448848/4692807878',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
